import styled from 'styled-components';

import { getSizeOption } from 'productTemplate/utils/getSizeOption';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { useGenderSizingLabel } from 'shared/hooks/useGenderSizingLabel';
import { useLogInBeforeAction } from 'productTemplate/hooks/useLogInBeforeAction';
import { useSizePreferencesModal } from 'sizePreferences/hooks/useSizePreferencesModal';
import { useStoreSelector } from 'store/hooks/storeHooks';
import { useWindowSize } from 'shared/hooks/useWindowSize';

interface IGenderSizing {
  className?: string;
  isClickable?: boolean;
}

export const GenderSizing = ({ className }: IGenderSizing) => {
  const { isMobile } = useWindowSize();
  const { sizeOptions, isFashionProduct } = useStoreSelector((state) => state.pdp.productTemplate);
  const { expandedSize } = useStoreSelector((state) => state.buyBar);
  const { size } = useStoreSelector((state) => state.pdpState);
  const conversionSize = isMobile ? Number(expandedSize) : size;
  const { openSizePreferencesModal } = useSizePreferencesModal();
  const sizeOption = getSizeOption(conversionSize, sizeOptions);
  const { genderSizeLabel, isLoading } = useGenderSizingLabel(sizeOption);
  const { isAuthenticated } = useStoreSelector((state) => state.auth);
  const { logInBeforeAction } = useLogInBeforeAction();

  const handleSizePreferencesClick = () => {
    if (!isAuthenticated) {
      logInBeforeAction(() => openSizePreferencesModal());
    } else {
      openSizePreferencesModal();
    }
    sendTrackingEvent('SIZE_PREF_TAP');
  };

  return (
    <>
      {!isLoading && (
        <GenderSizing.Button
          data-qa="open_size_preferences"
          onClick={handleSizePreferencesClick}
          type="button"
          disabled={isFashionProduct}
          className={className}
        >
          {genderSizeLabel}
        </GenderSizing.Button>
      )}
    </>
  );
};

GenderSizing.Button = styled.button`
  background-color: #fff;
  border: 1px solid #000;
  font-size: 12.5px;
  margin: 0 auto;
  padding-bottom: 1px;
  padding: 4px;
  white-space: nowrap;
  width: fit-content;

  &:disabled {
    cursor: default;
  }
`;
